import * as actionTypes from './actionTypes'

export const setSystemLoading = payload => ({
    type: actionTypes.SET_SYSTEM_LOADING,
    payload
})